export interface IPaginatedApiResponse<TItem> {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  items: TItem[];
}

export enum EDataSelectSourceType {
  STATIC = "static",
  API = "api",
}

export enum EDataSelectSearchMode {
  LOCAL = "local",
  API = "api",
}

export interface IDataSelectOption {
  uid: string;
  label: string;
  raw?: Record<string, unknown>;
}

export interface IDataSelectStaticSource {
  type: EDataSelectSourceType.STATIC;
  options: IDataSelectOption[];
}

export interface IDataSelectApiSourceBase {
  type: EDataSelectSourceType.API;
  url: string;
  bearerToken?: string;
  valueKey?: string;
  labelKey?: string;
  pageSize?: number;
  queryParams?: Record<string, string | number | boolean>;
  enabled?: boolean;
  minSearchLength?: number;
}

export interface IDataSelectApiSourceLocalSearch extends IDataSelectApiSourceBase {
  searchMode: EDataSelectSearchMode.LOCAL;
  searchParamKey?: never;
}

export interface IDataSelectApiSourceApiSearch extends IDataSelectApiSourceBase {
  searchMode: EDataSelectSearchMode.API;
  searchParamKey: string;
}

export interface IDataSelectApiSourceNoSearch extends IDataSelectApiSourceBase {
  searchMode?: undefined;
  searchParamKey?: never;
}

export interface IDataSelectProps {
  label: string;
  value: string | null;
  source: IDataSelectStaticSource | IDataSelectApiSourceLocalSearch | IDataSelectApiSourceApiSearch | IDataSelectApiSourceNoSearch;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  error?: boolean;
  noOptionsText?: string;
  onChange: (value: string | null, option: IDataSelectOption | null) => void;
  onSelectedRecordChange?: (record: Record<string, unknown> | null) => void;
}
